import { useSyncExternalStore } from 'react'

/** Nothing ever changes the snapshot, so the subscription has nothing to do. */
function subscribe(): () => void {
  return () => undefined
}

/**
 * `false` while the build renders and through the first client render, `true`
 * from the commit onward — the hook that lets a component add chrome the
 * prerendered bytes do not carry without tripping a hydration mismatch
 * (docs/operations/seo.md § How It Works).
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  )
}
